import { colors } from '@mui/material';
import { Avatar } from '@mui/material/node';
import * as React from 'react';

export const UserAvatar = (props) => {
    const [userData, setUserData] = React.useState({
        name: props.userData?.name,
        bio: props.userData?.bio,
        piculr: props.userData?.piculr
    });

    if (props.readolny && props.readolny === true) {
        return (
            <Avatar
                alt="user"
                sx={{ width: 128, height: 128, }}>
            </Avatar>
        );
    }
    else {
        return (
            <Avatar
                alt="user"
                src={props.userData?.picurl}
                sx={{ width: 128, height: 128,colors: "#123456" }}>
            </Avatar>
        );
    }
}